//
//
//
//
//
//
//
//
//

import Media from './zy.media.js'

export default {
  name: 'video',
  props: {
    cover: String,
    video: String
  },
  beforeCreate () {
    this._player = Media(this.$el.querySelector('video'))
  }
}
